import { createAction, props } from '@ngrx/store';

export const transactionAll = createAction('TRANSACTION_ALL', props<{items: any}>());
export const transactionList = createAction('TRANSACTION_LIST', props<{items: any}>());
export const transactionCreate = createAction('TRANSACTION_CREATE', props<{item: any}>());
export const transactionUpdate = createAction('TRANSACTION_UPDATE', props<{item: any}>());
export const transactionDelete = createAction('TRANSACTION_DELETE', props<{item: any}>());
